/**
 * Module dependencies.
 */

import { FormList } from 'app/components/organisms/crud/form-types';
import { requiredRule } from 'app/core/utils/field-rules';
import { TFunction } from 'react-i18next';
import { DrugsAssociationField } from './components/drugs-association-field';

/**
 * Left.
 */

const left = (translate: TFunction): FormList => [
  {
    type: 'inputField',
    inputType: 'textArea',
    name: 'description',
    rows: 10,
    translatable: true,
    label: translate('common.labels.description'),
    rules: requiredRule(translate)
  }
];

/**
 * Right.
 */

const right = (translate: TFunction): FormList => [
  {
    type: 'inputField',
    name: 'id',
    disabled: true,
    label: translate('common.labels.id'),
    rules: undefined
  },
  {
    type: 'inputField',
    name: 'createdAt',
    disabled: true,
    label: translate('common.labels.createdAt'),
    rules: undefined
  },
  {
    type: 'inputField',
    name: 'updatedAt',
    disabled: true,
    label: translate('common.labels.updatedAt'),
    rules: undefined
  }
];

/**
 * Middle.
 */

const middle = (): FormList => [
  {
    type: 'render',
    name: 'leftWire1',
    renderComponent: DrugsAssociationField
  }
];

/**
 * Export `formFields`.
 */

export const formFields = (translate: TFunction): FormList => [
  {
    type: 'columns',
    gutter: 40,
    name: 'mainWire',
    columns: [
      {
        column: 6,
        children: left(translate)
      },
      {
        column: 12,
        children: middle()
      },
      {
        column: 6,
        children: right(translate)
      }
    ]
  }
];
